import styles from './claim.module.scss';
import Fila from '../../Fila';

const Claim = () => {
    return (
        <div className={styles.claim}>
            <Fila tipus='fixed' columnes='12'>
                <div className={styles.frases}>
                <div className={styles.frase1}>
                    Perquè ho <span>veus</span>,
                </div>
                <div className={styles.frase2}>
                    Perquè ho <span>sents</span>,
                </div>
                <div className={styles.frase3}>
                    Perquè ho <span>vius</span>...
                </div>
            </div>
            <div className={styles.final}>No t&#39;ho pots perdre!</div>
            </Fila>
        </div>
    );
};

export default Claim;
